import React from 'react'
import classes from './Recommneted.module.css'
import { Link } from 'react-router-dom';

function Trending(recommendy) {
  let setRight = recommendy.recommendy.filter((item) => {
    console.log(item.type);
    return item.type === "trending";
  });

    
  return (
    <div className={classes.container}>
Trending
    <div className={classes.recomends}>
    {
  setRight && setRight.map((item) => (
    <Link to={`/details/:${item.id}`}>
    <div key={item.id} className={classes.recomend}>
      <img src={item.cardImg} alt="" />
    </div>
    </Link>
  ))
}
     
    </div>
    </div>
  )
  
}

export default Trending
